import * as helpers from '@mindtickle/ui-shell-core/Echo';

function useEchoHelpers() {
  return helpers;
}

export default useEchoHelpers;
